
// import debounce from 'debounce';
import { getCountryCallingCode } from 'libphonenumber-js';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import PROCESS_NAMES from '@/process/names';

function Debounce(wait: number, immediate: boolean = false) {
  return function (target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    var timeout: any;
    var originalMethod = descriptor.value;
    descriptor.value = function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) originalMethod.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) originalMethod.apply(context, args);
    };
    return descriptor;
  };
}

@Component({
  name: 'CreationRowEditable',
  computed: {
    ...mapState('vacancies', ['vacancies_total', 'list_dropdown']),
    ...mapGetters('process', ['getProcessName'])
  },
  methods: {
    ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),
    ...mapActions('vacancies', ['fetchVacanciesListDropdown'])
  }
})
export default class CreationRowEditable extends Vue {
  @Prop() readonly model: any;
  @Prop() readonly lastRow: any;
  @Prop() readonly recruiterCountry: any;
  @Prop() readonly edited: any;
  @Prop() readonly company: any;
  @Prop() readonly is_japan_locale: any;
  @Prop() readonly debounce: any;
  @Prop() readonly queryVacancy: any;

  getProcessName!: string;
  $tr!: any;

  // do not validate vacancy multiselect untill first select open
  private shouldValidateVacancy = false;
  private vacancySearch = '';
  private vacancyCooldown = false;
  private insertedFromExcel = false;
  private validPhone = false;
  private isInnerCandidate = false;
  private vacancy_mod = false;
  private loading_more = false;
  private searchTerm = '';
  private count = 20;
  private getCountryCallingCode = getCountryCallingCode;

  get invitesValidStatus() {
    return this.$store.getters['invites/creation/invitesValidStatus'];
  }

  get insertedFromExcelIds() {
    return this.$store.getters['invites/creation/insertedFromExcelIds'];
  }
  get activeInviteLocalId() {
    return this.$store.getters['invites/creation/activeInviteLocalId'];
  }

  get vacancies_null() {
    return this.list_dropdown.length === 0;
  }

  get inviteStatuses() {
    return this.invitesValidStatus || [];
  }

  get insertedIds() {
    return this.insertedFromExcelIds || [];
  }

  get email_error() {
    if (this.model.errors && this.model.errors.email) {
      return this.model.errors.email[0];
    }

    if (this.errors.has('email') && this.errors.first('email')) {
      return this.errors.first('email');
    }

    return '';
  }

  get vacancyCode() {
    const country = this.vacancy ? this.vacancy.country : null;

    return country ? country.code : null;
  }

  get vacancyIsSelected() {
    return this.vacancy.id !== null;
  }

  get emptyRow() {
    return !(
      this.vacancy.id ||
      this.candidateName ||
      this.candidateSurname ||
      this.candidateEmail ||
      this.candidatePhone
    );
  }

  get valid() {
    const fields = Object.keys(this.fields).map(k => this.fields[k]);
    //   const isPhoneValid = this.candidatePhone ? this.validPhone : true;

    return this.vacancyValid && (fields && fields.length ? fields.every(f => f.valid === true) : true);
  }

  get vacancyValid() {
    return this.vacancy.id !== null;
  }

  get candidate() {
    return this.model.candidate;
  }

  get localId() {
    return this.model.localId;
  }

  get vacancy() {
    return this.model.vacancy;
  }

  set vacancy(vacancy) {
    // Cooldown fot bug double select
    // when select via search
    if (!this.vacancyCooldown) {
      this.$store.dispatch('invites/creation/updateVacancy', {
        localId: this.model.localId,
        vacancy,
        edited: this.model.edited
      });

      if (vacancy && vacancy.id !== null) {
        this.vacancyCooldown = true;
        setTimeout(() => {
          this.vacancyCooldown = false;
          this.$refs.vacancy.select({
            id: vacancy.id,
            name: vacancy.name
          });
        }, 50);
      }
    }
  }

  get candidateName() {
    return this.model.candidate.name;
  }

  set candidateName(val) {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      candidate: { name: val },
      tags: this.model.tags,
      edited: this.model.edited
    });
  }

  get candidateSurname() {
    return this.model.candidate.surname;
  }

  set candidateSurname(val) {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      candidate: { surname: val },
      tags: this.model.tags,
      edited: this.model.edited
    });
  }

  get candidateEmail() {
    return this.candidate.email;
  }

  set candidateEmail(val) {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      candidate: { email: val },
      tags: this.model.tags,
      edited: this.model.edited
    });
  }

  get candidatePhone() {
    let default_phone;
    if (this.vacancy.country !== undefined) {
      default_phone = this.getCountryCallingCode(this.vacancy.country.code);
    } else if (this.recruiterCountry !== '' && this.recruiterCountry !== null) {
      default_phone = this.getCountryCallingCode(this.recruiterCountry);
    } else {
      default_phone = '';
    }
    return this.candidate.phone ? this.candidate.phone + '' : '+' + default_phone;
  }

  set candidatePhone(val) {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      candidate: { phone: val },
      tags: this.model.tags,
      edited: this.model.edited
    });
  }

  get candidateTags() {
    return this.model.tags;
  }

  set candidateTags(val) {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      tags: val,
      edited: this.model.edited
    });
  }

  get isCyrillicRequired() {
    if (this.getProcessName === PROCESS_NAMES.SPORTMASTER) {
      return { required: true, regex: /^[А-ЯЁа-яё -]*$/ };
    }

    return {};
  }

  get onlyRussianSymbolsName() {
    if (
      this.isCyrillicRequired &&
      Object.keys(this.isCyrillicRequired).length > 0 &&
      this.isCyrillicRequired.constructor === Object &&
      !/^[А-ЯЁа-яё -]*$/.test(this.candidateName) &&
      this.candidateName
    ) {
      return true;
    }

    return false;
  }

  get onlyRussianSymbolsSurname() {
    if (
      this.isCyrillicRequired &&
      Object.keys(this.isCyrillicRequired).length > 0 &&
      this.isCyrillicRequired.constructor === Object &&
      !/^[А-ЯЁа-яё -]*$/.test(this.candidateSurname) &&
      this.candidateSurname
    ) {
      return true;
    }

    return false;
  }

  public set_edited() {
    this.$store.dispatch('invites/creation/updateCandidate', {
      localId: this.model.localId,
      edited: true,
      tags: this.model.tags,
      open: true
    });
  }
  public changeValidPhone(val) {
    this.validPhone = val;
  }

  public fetch() {
    this.loading_more = true;
    let params = {
      searchTerm: this.searchTerm
    };

    this.fetchVacanciesListDropdown(params)
      .then(() => {
        this.loading_more = false;
      })
      .catch(() => {
        this.loading_more = false;
      });
  }

  @Debounce(500)
  public asyncFind(v) {
    this.searchTerm = v;
    this.fetch();
    this.changeSearch(v);
  }

  // Drop vacancy on search
  public changeSearch(searchQuery) {
    if (searchQuery !== '' && this.vacancy.id !== null) {
      this.validateVacancy();
      this.vacancy = { id: null, name: '' };
    }
  }

  public deleteRow() {
    this.errors.clear();
    this.$emit('delete-row');
  }

  // Use $refs because vue-multiselect can`t
  // handle @blur event, and we need simulate
  // drop select variant if nothing found
  public closeVacancy() {
    this.validateVacancy();
    setTimeout(() => {
      this.toggle_vacancy_modal();
    }, 200);
    if (this.vacancy.id === null) {
      this.$refs.vacancy.select({ id: null, name: '' });
    }
  }

  // so that vacancy could be shown with red border
  public validateVacancy() {
    this.shouldValidateVacancy = true;
  }

  public selectOpened() {
    this.toggle_vacancy_modal();
  }

  public toggle_vacancy_modal() {
    this.vacancy_mod = !this.vacancy_mod;
  }

  public load_more(is_active = true) {
    this.count = this.count + 20;
    this.CHANGE_PAGINATION_COUNT(this.count);
    this.fetch();
  }

  beforeMount() {
    if (this.queryVacancy) {
      this.vacancy = this.queryVacancy;
      this.$router.replace(this.$route.path);
    }
    const curStatus = this.inviteStatuses.find(s => s.localId === this.model.localId);

    if (curStatus && (curStatus.valid !== this.valid || curStatus.emptyRow !== this.emptyRow)) {
      this.$store.commit('invites/creation/updateStatus', {
        localId: this.model.localId,
        newData: {
          valid: this.valid,
          emptyRow: this.emptyRow
        },
        edited: true
      });
    }

    // Case when this invite is inserted from xls file
    if (this.insertedIds.includes(this.model.localId)) {
      this.insertedFromExcel = true;
      this.$nextTick(() => {
        this.$validator.validateAll();
      });
    }

    if (this.$route && this.$route.query && this.$route.query.id && this.model.localId === 0) {
      this.vacancy = {
        id: this.$route.query.id,
        name: this.$route.query.name
      };
    }
  }
}
